import type { WorkIndexCaseStudyId } from "~/content/work-index"

const imgBoldnyFeatureJpg = "/images/work/9f9b0.png"
const imgChillInDashboardOriginalImage = "/images/work/6ec29.png"
const imgDapperWalletJpg = "/images/work/3b875.png"
const imgForemImageJpg = "/images/work/eca3a.png"
const imgHadleyContributionsOriginalImage = "/images/work/a38b6.png"
const imgHadleySavingsOriginalImage = "/images/work/ef30f.png"
const imgHeatseekHardwareJpg = "/images/work/9a7d0.png"
const imgKindredFeature1Jpg = "/images/work/d3fd0.png"
const imgLeapFundCalculatorOriginalImage = "/images/work/2a8a1.png"
const imgMakerBotLogoOriginalImage = "/images/work/7b04b.png"
const imgMosaicDesktopOriginalImage = "/images/work/86925.png"
const imgMosaicMobileOriginalImage = "/images/work/85e1f.png"
const imgObe2Jpg = "/images/work/efea1.png"
const imgQuadrantDashboardOriginalImage = "/images/work/66200.png"
const imgReportableJpg = "/images/work/8766c.png"
const imgSs2Jpg = "/images/work/4b862.png"
const imgTarget100B201C6E1Png = "/images/work/749d0.png"
const imgTheinformationAppJpg = "/images/work/06d17.png"
const imgTmpWorkCoverConceptsBrightlinesPng = "/images/work/c57a4.png"
const imgTmpWorkCoverConceptsChat1Webp = "/images/work/a9c93.png"
const imgTmpWorkCoverConceptsPearlandPng = "/images/work/1a801.png"
const imgWorkweek1Jpg = "/images/work/9cd54.png"

const covers = {
  "the-information": (
    <div
      className="bg-[#edece8] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[13.57668cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[31.83497cqw]"
        data-name="The Information / Cropped source"
      >
        <div
          className="absolute h-[89.15314cqw] left-[-13.08277cqw] top-[-12.32669cqw] w-[145.18574cqw]"
          data-name="theinformation-app.jpg"
        >
          <img
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTheinformationAppJpg}
          />
        </div>
      </div>
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[52.90223cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[31.83497cqw]"
        data-name="The Information / Cropped source"
      >
        <div
          className="absolute h-[89.36522cqw] left-[-56.84884cqw] top-[-12.35478cqw] w-[145.53124cqw]"
          data-name="theinformation-app.jpg"
        >
          <img
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTheinformationAppJpg}
          />
        </div>
      </div>
    </div>
  ),
  "hadley": (
    <div
      className="bg-[#eee9fc] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[64.84035cqw] left-[14.51300cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[8.42690cqw] w-[30.43049cqw]"
        data-name="Hadley savings"
      >
        <div
          className="absolute h-[77.58675cqw] left-[-37.47632cqw] top-[-2.77152cqw] w-[108.89855cqw]"
          data-name="Hadley savings / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgHadleySavingsOriginalImage}
          />
        </div>
      </div>
      <div
        className="absolute bg-white h-[64.84035cqw] left-[51.26367cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[8.42690cqw] w-[35.34618cqw]"
        data-name="Hadley contributions"
      >
        <div
          className="absolute h-[82.33577cqw] left-[-54.33715cqw] top-[-7.06924cqw] w-[93.00892cqw]"
          data-name="Hadley contributions / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgHadleyContributionsOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "dapper-labs": (
    <div
      className="bg-[#e6f4ee] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[33.70762cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[32.53722cqw]"
        data-name="Dapper Labs / Cropped source"
      >
        <div
          className="absolute left-[-43.41260cqw] size-[85.57732cqw] top-[-9.09169cqw]"
          data-name="dapper-wallet.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgDapperWalletJpg}
          />
        </div>
      </div>
    </div>
  ),
  "target100": (
    <div
      className="bg-[#e9f3f3] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[37.68699cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[24.34439cqw]"
        data-name="Target100 / Cropped source"
      >
        <div
          className="absolute h-[70.72912cqw] left-[-58.25332cqw] top-[-1.73922cqw] w-[83.46638cqw]"
          data-name="target100-b201c6e1.png"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTarget100B201C6E1Png}
          />
        </div>
      </div>
    </div>
  ),
  "quadrant": (
    <div
      className="bg-[#e7eef7] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[66.71300cqw] left-[7.49058cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[7.49058cqw] w-[84.97129cqw]"
        data-name="Quadrant dashboard"
      >
        <div
          className="absolute h-[100.31434cqw] left-[-3.33097cqw] top-[-16.75081cqw] w-[91.69362cqw]"
          data-name="Quadrant dashboard / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgQuadrantDashboardOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "obe-fitness": (
    <div
      className="bg-[#fbe9f1] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[34.17578cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[31.60089cqw]"
        data-name="obé Fitness / Cropped source"
      >
        <div
          className="absolute left-[-43.20895cqw] size-[102.04373cqw] top-[-18.44322cqw]"
          data-name="obe2.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgObe2Jpg}
          />
        </div>
      </div>
    </div>
  ),
  "reportable-news": (
    <div
      className="bg-[#f5e8ed] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[53.13632cqw] left-[7.49058cqw] overflow-clip rounded-[1.87265cqw] top-[14.27892cqw] w-[84.97129cqw]"
        data-name="Reportable / Cropped source"
      >
        <div
          className="absolute h-[104.83210cqw] left-[-5.52899cqw] top-[-26.20767cqw] w-[95.82304cqw]"
          data-name="reportable.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgReportableJpg}
          />
        </div>
      </div>
    </div>
  ),
  "skillschool": (
    <div
      className="bg-[#e8efeb] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[13.81076cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[33.94170cqw]"
        data-name="SkillSchool / Cropped source"
      >
        <div
          className="absolute left-[-21.10471cqw] size-[168.82929cqw] top-[-71.75275cqw]"
          data-name="ss-2.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgSs2Jpg}
          />
        </div>
      </div>
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[52.19999cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[33.94170cqw]"
        data-name="SkillSchool / Cropped source"
      >
        <div
          className="absolute left-[-115.63118cqw] size-[168.82929cqw] top-[-36.05311cqw]"
          data-name="ss-2.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgSs2Jpg}
          />
        </div>
      </div>
    </div>
  ),
  "mosaic-foods": (
    <div
      className="bg-[#e5efeb] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[57.58385cqw] left-[5.61794cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[11.23587cqw] w-[81.92824cqw]"
        data-name="Mosaic desktop"
      >
        <div
          className="absolute h-[57.60585cqw] left-0 top-0 w-[81.92824cqw]"
          data-name="Mosaic desktop / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgMosaicDesktopOriginalImage}
          />
        </div>
      </div>
      <div
        className="absolute bg-white h-[52.66815cqw] left-[66.94708cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[23.40807cqw] w-[27.38744cqw]"
        data-name="Mosaic mobile"
      >
        <div
          className="absolute h-[59.26923cqw] left-0 top-0 w-[27.38744cqw]"
          data-name="Mosaic mobile / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgMosaicMobileOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "makerbot": (
    <div
      className="bg-[#333] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[51.73183cqw] left-[17.55605cqw] overflow-clip rounded-[1.87265cqw] top-[14.98116cqw] w-[64.84035cqw]"
        data-name="MakerBot logo"
      >
        <div
          className="absolute left-[-18.60239cqw] size-[102.04373cqw] top-[-23.91602cqw]"
          data-name="MakerBot logo / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgMakerBotLogoOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "heat-seek": (
    <div
      className="bg-[#f4eee5] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute h-[45.41165cqw] left-[26.68520cqw] overflow-clip rounded-[23.40807cqw] top-[18.02421cqw] w-[46.58206cqw]"
        data-name="Heat Seek / Cropped source"
      >
        <div
          className="absolute h-[136.90677cqw] left-[-45.66212cqw] top-[-23.71237cqw] w-[147.34349cqw]"
          data-name="heatseek-hardware.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgHeatseekHardwareJpg}
          />
        </div>
      </div>
    </div>
  ),
  "bold-new-york": (
    <div
      className="bg-[#e8f0f2] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[66.71300cqw] left-[10.53363cqw] overflow-clip rounded-[1.87265cqw] top-[7.49058cqw] w-[78.65111cqw]"
        data-name="Bold New York / Cropped source"
      >
        <div
          className="absolute h-[79.14619cqw] left-[-13.47603cqw] top-[-12.37585cqw] w-[105.60152cqw]"
          data-name="boldny-feature.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgBoldnyFeatureJpg}
          />
        </div>
      </div>
    </div>
  ),
  "the-forem": (
    <div
      className="bg-[#f9ede8] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[66.71300cqw] left-[19.42870cqw] overflow-clip rounded-[1.87265cqw] top-[7.49058cqw] w-[61.09506cqw]"
        data-name="The Forem / Cropped source"
      >
        <div
          className="absolute h-[82.28732cqw] left-[-5.72795cqw] top-[-4.96485cqw] w-[73.31407cqw]"
          data-name="forem-image.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgForemImageJpg}
          />
        </div>
      </div>
    </div>
  ),
  "kindred": (
    <div
      className="bg-[#eeedf5] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[55.00896cqw] left-[5.61794cqw] overflow-clip rounded-[1.87265cqw] top-[11.23587cqw] w-[81.92824cqw]"
        data-name="Kindred / Cropped source"
      >
        <div
          className="absolute h-[87.70418cqw] left-[-14.83837cqw] top-[-9.86416cqw] w-[170.60971cqw]"
          data-name="kindred-feature-1.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgKindredFeature1Jpg}
          />
        </div>
      </div>
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[52.66815cqw] left-[66.94708cqw] overflow-clip rounded-[1.87265cqw] top-[23.40807cqw] w-[27.38744cqw]"
        data-name="Kindred / Cropped source"
      >
        <div
          className="absolute h-[91.16015cqw] left-[-105.01328cqw] top-[-10.34403cqw] w-[177.33297cqw]"
          data-name="kindred-feature-1.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgKindredFeature1Jpg}
          />
        </div>
      </div>
    </div>
  ),
  "brightlines": (
    <div
      className="bg-white h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute h-[15.21524cqw] left-[12.64036cqw] overflow-clip top-[33.23946cqw] w-[74.67174cqw]"
        data-name="Brightlines / Cropped source"
      >
        <div
          className="absolute h-[15.24544cqw] left-0 top-0 w-[74.67174cqw]"
          data-name="/tmp/work-cover-concepts/brightlines.png"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTmpWorkCoverConceptsBrightlinesPng}
          />
        </div>
      </div>
    </div>
  ),
  "chatbcc": (
    <div
      className="bg-[#edf4e4] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[64.84035cqw] left-[32.53722cqw] overflow-clip rounded-[1.87265cqw] top-[8.42690cqw] w-[35.11210cqw]"
        data-name="ChatBCC / Cropped source"
      >
        <div
          className="absolute h-[95.88858cqw] left-[-4.51308cqw] top-[-31.02271cqw] w-[44.27800cqw]"
          data-name="/tmp/work-cover-concepts/chat1.webp"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTmpWorkCoverConceptsChat1Webp}
          />
        </div>
      </div>
    </div>
  ),
  "workweek-communities": (
    <div
      className="bg-[#f1e7f3] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute drop-shadow-[0.00000cqw_1.40448cqw_2.10673cqw_rgba(0,0,0,0.12)] h-[48.68878cqw] left-[7.49058cqw] overflow-clip rounded-[1.87265cqw] top-[16.38565cqw] w-[84.97129cqw]"
        data-name="WorkWeek Communities / Cropped source"
      >
        <div
          className="absolute left-[-22.46238cqw] size-[233.12329cqw] top-[-45.53103cqw]"
          data-name="workweek-1.jpg"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgWorkweek1Jpg}
          />
        </div>
      </div>
    </div>
  ),
  "chill-in": (
    <div
      className="bg-[#e4f2f7] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[66.71300cqw] left-[7.49058cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[7.49058cqw] w-[84.97129cqw]"
        data-name="Chill In dashboard"
      >
        <div
          className="absolute left-[-14.19465cqw] size-[113.55394cqw] top-[-23.53915cqw]"
          data-name="Chill In dashboard / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgChillInDashboardOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "leapfund": (
    <div
      className="bg-[#e9eff7] h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute bg-white h-[51.73183cqw] left-[7.49058cqw] overflow-clip rounded-[1.87265cqw] shadow-[0.00000cqw_1.40448cqw_4.21345cqw_0.00000cqw_rgba(0,0,0,0.12)] top-[14.98116cqw] w-[84.97129cqw]"
        data-name="Leap Fund calculator"
      >
        <div
          className="absolute h-[51.96404cqw] left-[-7.58187cqw] top-0 w-[100.58283cqw]"
          data-name="Leap Fund calculator / Original image"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgLeapFundCalculatorOriginalImage}
          />
        </div>
      </div>
    </div>
  ),
  "pearland": (
    <div
      className="bg-white h-[81.77468cqw] overflow-clip relative rounded-[3.74529cqw] shrink-0 w-[99.99997cqw]"
      data-name="Cover image"
    >
      <div
        className="absolute h-[34.87802cqw] left-[14.98116cqw] overflow-clip top-[23.40807cqw] w-[69.99012cqw]"
        data-name="Pearland Brokerage / Cropped source"
      >
        <div
          className="absolute h-[34.87802cqw] left-0 top-0 w-[70.06784cqw]"
          data-name="/tmp/work-cover-concepts/pearland.png"
        >
          <img
            loading="lazy"
            decoding="async"
            alt=""
            className="absolute inset-0 max-w-none object-cover pointer-events-none size-full"
            src={imgTmpWorkCoverConceptsPearlandPng}
          />
        </div>
      </div>
    </div>
  ),
}

export const WorkCover = ({ id }: { id: WorkIndexCaseStudyId }) => (
  <div className="work-cover" aria-hidden="true">
    {covers[id]}
  </div>
)
